import React from 'react'
import { useHistory } from 'react-router-dom'
import { IconWatches } from 'svg'

import './TrialOverBanner.scss'

export const TrialOverBanner = ({ t }) => {
    const history = useHistory()

    function onClickLink({ state }) {
        const path = '/billing-and-payments?tab=subscription'
        history.push(path, { state })
    }

    return (
        <div className="trial-over-banner banner" data-padding="normal" data-variant="normal">
            <div className="banner-box container-fluid">
                <div>
                    <span className="icon" data-icon="attention">
                        <IconWatches />
                    </span>
                    <div className="trial-over-banner__message">
                        {t('Sorry, the trial period is over. To continue, choose the plan that suits you.')}
                    </div>
                </div>
                <button
                    className="button"
                    data-size="md"
                    data-variant="primary-light"
                    data-test="choose-subscription-options"
                    onClick={onClickLink}
                >
                    {t('Choose a plan')}
                </button>
            </div>
        </div>
    )
}

export default TrialOverBanner
